import getObjectKey from 'lib/object/getObjectKey'

function buildLoyaltySelectedUpgradeKey(originPackage: App.Package, targetUpgradePackage: App.Package | undefined): string | undefined {
  if (!originPackage.roomRate?.id || !targetUpgradePackage) {
    return
  }

  return getObjectKey({
    originLePackageId: originPackage.lePackageId,
    originRoomRateId: originPackage.roomRate.id,
    targetUpgradeLePackageId: targetUpgradePackage.lePackageId,
  })
}

export default buildLoyaltySelectedUpgradeKey
